// @codingStandardsIgnoreFile
/**
 * Edit function - renders the block
 *
 * @param {object} props
 * @return {domObject}
 */
const edit = (props) => {
	return <div className={props.attributes.className}>
		MetaSlider - Slider ID: {props.attributes.slider_id}
	</div>
}

export default edit



// WEBPACK FOOTER //
// ./src/admin/assets/js/gutenberg/components/block-edit.js